import Section from "@/components/Section";
import { FONT_PRIMARY } from "@/theme/typography";
import { ROUTES } from "@/utils/navigation";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

const QuestionsSection = () => {
  const theme = useTheme();
  return (
    <Section pt={{ xs: 7.5, lg: 15 }} pb={{ xs: 7.5, lg: 17.5 }}>
      <Box
        sx={{
          backgroundColor: "#F9FAFC",
          padding: { xs: "24px", lg: "32px" },
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "16px",
        }}
      >
        <Box
          sx={{
            marginRight: { xs: "0px", lg: "20px" },
          }}
        >
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "1.5rem !important",
              textAlign: "start",
              fontFamily: FONT_PRIMARY,
              marginBottom: "8px",
            }}
          >
            Have questions?
          </Typography>
          <Typography
            sx={{
              color: theme.palette.text.secondary,
              fontSize: { xs: "1rem", md: "1.125rem" },
              marginBottom: { xs: "32px", lg: "0px" },
              textAlign: "start",
            }}
          >
            Can’t find the answer you’re looking for? Please chat to our
            friendly team
          </Typography>
        </Box>
        <Button
          component={Link}
          to={ROUTES.contactUs}
          variant="contained"
          color="primary"
          disableElevation
          sx={{
            paddingY: "14px",
            paddingX: "65px",
            height: "50px",
            textWrap: "nowrap",
            maxWidth: { xs: "295px", md: "222px" },
            width: "100%",
          }}
        >
          Get in touch
        </Button>
      </Box>
    </Section>
  );
};

export default QuestionsSection;
